<div class="sanitization-container">

  <!-- Description -->
  <div class="m-4">
    <p class="text-muted mb-0">
      {{ 'lang.sanitization_description' | translate }}
    </p>
  </div>

  <!-- Dynamic Readings -->
  <div class="mb-4">

    @for (reading of sanitizationDetails?.readings; track reading; let last = $last) {
      <div
        class="d-flex justify-content-between p-3 border-bottom"
        >
        <!-- Left: Type -->
        <div class="text-capitalize">
          {{ reading.type === 'orp' ? reading.type.toUpperCase() : (reading.type | titlecase) }} Reading
        </div>
        <!-- Center: Value + Status -->
        <div class="unit-value equipment-status">
          {{ reading.value }} {{ reading.unit }} |
          @if (getStatusIcon(reading)) {
          <img class="m-1" [src]="getStatusIcon(reading)" />
          }
          <span>
            {{ getStatusLabel(reading) | splitCamelCaseTitle }}
          </span>
        </div>
        <!-- Right: Range Link -->
        <div>
          <a class="label-range-level"
            style="cursor: pointer"
            (click)="reading.type === 'orp' ? openModal(scaleType.Orp) : (reading.type === 'salt' ? openModal(scaleType.Salt) : null)">
            {{ reading.type === 'orp' ? reading.type.toUpperCase() : (reading.type | titlecase) }} Range Level Table
          </a>
        </div>
      </div>
    }
  </div>

  <!-- Equipment Placeholder -->
  <div class="equipment-section">
    @for (equipment of sanitizationEquipmentList; track equipment) {
      <div class="border-style-equipment mt-4">
        <!-- Equipment Name -->
        <div class="equipment-name m-2">
          <img class="equipment-icon" [src]="getEquipmentIcon(equipment.type)" />
          <span>{{ equipment.displayName }}</span>
        </div>
        <hr class="mt-0 mb-0 ml-2 mr-2">
        <div class="grid-container p-2">
          <!-- For Chlorinator -->
          @if (equipment.type === 'sanitizer') {
            <!-- Equipment Status -->
            <div class="grid-item m-2">
              <span class="equipment-grid">{{ 'lang.equipment_status' | translate }}</span><br>
              <span class="equipment-grid-value">
                {{ equipment?.equipmentStatus?.power }}
                {{equipment?.equipmentStatus?.operationMode ? ' | ' + equipment?.equipmentStatus?.operationMode : ''}}
                {{equipment?.equipmentStatus?.modeTimeRemaining ? ' | ' + equipment?.equipmentStatus?.modeTimeRemaining + ' left': ''}}
              </span>
            </div>
            <!-- Chlorinator Output Level -->
            <div class="grid-item m-2">
              <span class="equipment-grid">Chlorinator Output Level</span><br>
              <span class="equipment-grid-value">{{ equipment.chlorinatorOutputLevel }}%</span>
            </div>
          }
          <!-- For TruSense -->
          @if (equipment.type === 'truSense') {
            <!-- Equipment Status -->
            <div class="grid-item m-2">
              <span class="equipment-grid">{{ 'lang.equipment_status' | translate }}</span><br>
              <span class="equipment-grid-value">{{ equipment.status }}</span>
            </div>
            <!-- Last pH Calibration Date -->
            <div class="grid-item m-2">
              <span class="equipment-grid">Last pH Calibration Date</span><br>
              <span class="equipment-grid-value">
                {{ equipment.calibration?.lastPHCalibrationDate }}
              </span>
            </div>
            <!-- Last ORP Calibration Date -->
            <div class="grid-item m-2">
              <span class="equipment-grid">Last ORP Calibration Date</span><br>
              <span class="equipment-grid-value">
                {{ equipment.calibration?.lastORPCalibrationDate }}
              </span>
            </div>
          }
        </div>
      </div>
    }
  </div>

</div>